// ----------------------------------------------------------------------------
// Snippet: Card
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/background-media/background-media';
import 'snippets/reviews/reviews';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';

// Styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_card.scss';

document.addEventListener('DOMContentLoaded', function () {
    const swatchOptions = document.querySelectorAll('.card__color-swatches .swatch__option');

    swatchOptions.forEach(function (swatchOption) {
        swatchOption.addEventListener('mouseover', handleClick);
        swatchOption.addEventListener('click', handleClick);
    });

    function handleClick() {
        let selectedSwatch = this;

        if (!selectedSwatch.classList.contains('selected')) {
            let productCard = selectedSwatch.closest('.card--product');
            let selectedSwatches = productCard.querySelectorAll('.swatch__option.selected');

            selectedSwatches.forEach(function (selectedSwatch) {
                selectedSwatch.classList.remove('selected');
            });

            selectedSwatch.classList.add('selected');

            let currentSwatchURL = selectedSwatch.getAttribute('data-swatch-url');
            let currentSwatchImage1 = selectedSwatch.getAttribute('data-swatch-image1');
            let currentSwatchImage2 = selectedSwatch.getAttribute('data-swatch-image2');

            productCard.querySelector('.background-image-1').src = currentSwatchImage1;
            productCard.querySelector('.background-image-2').src = currentSwatchImage2;
            productCard.querySelector('a').href = currentSwatchURL;
        }
    }
});

function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--swatches-list").each(function(index, element){
        let $this = $(this);

        const mobileSlidesPerView = $this.attr("data-mobile-swatch");
        const tabletSlidesPerView = $this.attr("data-tablet-swatch");
        const desktopSlidesPerView = $this.attr("data-desktop-swatch");

        // Generate unique class for each feature collection slider
        $this.addClass("swatches-list-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.color-swatches__container--carousel').find(".swiper-button-prev").addClass("swatches-list-btn-prev-" + index);
        $this.parents('.color-swatches__container--carousel').find(".swiper-button-next").addClass("swatches-list-btn-next-" + index);

        // Initialize feature collection slider based on the unique classes generated above.
        let swiper = new Swiper(".swatches-list-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
            slidesPerView: mobileSlidesPerView,
            spaceBetween: 0,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: tabletSlidesPerView,
                },
                1024: {
                    slidesPerView: desktopSlidesPerView,
                }
            },

            // Navigation arrows
                navigation: {
                nextEl: ".swatches-list-btn-next-" + index,
                prevEl: ".swatches-list-btn-prev-" + index
            },
        });
    });
});

//Swiper JS alters the swatches width by adding inline css causing the swatches to have uneven space
//This function mirrors the first slider width across all carousels.
window.addEventListener('load', function () {
    function adjustSwiperSlideWidth() {
        $(".product-cards__wrapper").each(function(){
            let $this = $(this);
            let slider_card = $this.find(".card--product .color-swatches__container--carousel .swiper-slide").not(".color-swatches__container--carousel--desktop-no-arrows");
            let swiper_slide_width = slider_card.width() + "px";

            if( slider_card.width() <= 0 ) {
                swiper_slide_width = "auto";
            }

            $this.find(".card__color-swatches .card__swatch-option--no-swiper").width(swiper_slide_width);

            if($(window).width() >= 680){
                $this.find(".color-swatches__container--carousel--desktop-no-arrows .swiper-slide").css("max-width", swiper_slide_width);

            }else {
                $this.find(".color-swatches__container--carousel--desktop-no-arrows .swiper-slide").css("max-width", swiper_slide_width);
                $this.find(".color-swatches__container--carousel--mobile-no-arrows .swiper-slide").css("max-width", swiper_slide_width);
            }
        });
    }

    window.addEventListener('resize', adjustSwiperSlideWidth);
    adjustSwiperSlideWidth();
});
